var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1,
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.999,
    cy: 23.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.999 31c-.985-1.847-2.908-3-5-3-2.093 0-4.016 1.153-5 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.999,
    cy: 23.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.999 31c-.985-1.847-2.908-3-5-3-2.093 0-4.016 1.153-5 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.999,
    cy: 4.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33 11c-1.08-1.27-2.665-2.001-4.333-2.001-1.668 0-3.252.731-4.333 2.001M12.067 26.276c2.553.974 5.377.965 7.925-.024M8.464 8c-2.213 2.072-3.468 4.969-3.467 8 0 .337.02.667.051 1M26.948 17c.03-.33.05-.667.05-1 .002-3.032-1.253-5.928-3.466-8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTeam);
export default __webpack_public_path__ + "static/media/project-team.6258842735bef87fc7f6f192e7976946.svg";
export { ForwardRef as ReactComponent };